<template>
    <div>
        <FlyerlineModal :name="name" class="flyerline-modal--small">
            <div>
                <div :hidden="hide" >
                    <h3 class="text-shade-darker">{{'txtSendOffer'|translate}}</h3>
                    <p class="text-small mb-prj2">{{'txtSendOfferHelpText'|translate}}</p>
                    <SkyFormLoader form-name="prj_productoffer" class="label--small" @success="handleSuccess" @beforeSubmit="handleBeforeSubmit"></SkyFormLoader>
                </div>
                <div :hidden="!hide">
                    <div class="d-flex p-2 line-height-14">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 36 36" xml:space="preserve" class="mr-2 svg-icon flex-child-fix position-relative t-2px">
                        <path d="M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z" fill="#62b982"/>
                        <path id="XMLID_1_" d="M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z" fill="#fff"/>
                        </svg>
                        <div>
                            <h3 class="text-shade-darker mb-0 position-relative tn-1px">{{'txtSendOfferSended'|translate}}</h3>
                            <p class="mb-0">{{'txtSendOfferSuccessful'|translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </FlyerlineModal>
        <slot :open="open" />
    </div>
</template>

<script>
    import FlyerlineModal from "fragments/FlyerlineModal.vue";
    import SkyFormLoader from "fragments/SkyFormLoader.vue";

    export default {
        components: {SkyFormLoader, FlyerlineModal},
        name: "SendProductOfferModal",
        props: ['name'],
        inject: ['configuratorService'],
        data() {
            return {
                hide: false,
            }
        },
        computed: {
        },
        methods: {
            open () {
                this.hide = false;
                this.$modal.show('send-productOffer')
            },
            handleSuccess () {
                this.hide = true
            },
            handleBeforeSubmit () {
                document.getElementById("productId").value = this.configuratorService.productId;
                document.getElementById("configuration").value = JSON.stringify(this.configuratorService.lightweightConf());
            }
        }
    }
</script>

<style scoped>

</style>